<template>
    <div id="app" class="mainContainer">
        <div class="headerBar" v-if="allowSpeech">
            <div class="headerText">
                Virtual Concierge
            </div>
            <button @click="closeAva"></button>
        </div>
        <div id="welcomeDiv" v-if="!allowSpeech">
            <div class="btnDiv" ref="btns" v-if="isReady">
                <div id="yesBtn" class="YNbtn" @click="startAva"></div>
                <div id="noBtn" class="YNbtn" @click="closeAva"></div>
            </div>
            <!--<div class="btnDiv" ref="btns" v-if="!isReady">
            Loading...
            </div>-->
        </div>
        <div v-if="allowSpeech">
            <Ava/>
            <Dialog/>
        </div>
    </div>
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import Ava from "./components/Ava.vue";
    import Dialog from "./components/Dialog.vue";
    import { mapState, mapActions, mapGetters } from 'vuex';

    export default {
        name: 'App',
        directives: { focus },
        components: {
            Ava,
            Dialog
        },
        created() {
            this.$store.dispatch('loadAva'),
                this.$store.dispatch('preloadAnimations'),
                // start Ava bot conversation
                this.$store.dispatch('startConversation'),
                // get user icon from campus
                this.$store.dispatch('fetchUserData');
        },
        computed: {
            ...mapState({
                allowSpeech: state => state.allowSpeech,
                isReady: state => state.isReady,
                selectedDialogGroup: state => state.selectedDialogGroup
            })
        },
        methods: {
            ...mapActions({
                startAva: 'startAva',
                closeAva: 'closeAva'
            })
        }
    }
</script>
<style>

    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        font-size: small;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #f0f3f5;
    }

    body {
        /*background-image: url('assets/images/BG.jpg');
        background-repeat: no-repeat !important;
        background-position: center;*/
    }

    .mainContainer {
        height: 548px;
        width: 922px;
        margin: auto;
    }

    .headerBar {
        position: relative;
        height: 28px;
        width: 922px;
        border-bottom: 2px solid #030303;
        background-color: rgb(26, 25, 25);
    }

    .headerText {
        display: inline-block;
        position: absolute;
        text-align: start;
        vertical-align: middle;
        left: 20px;
        top: 7px;
        font-weight: 500;
    }

    button {
        width: 20px;
        height: 20px;
        margin: 0;
        position: absolute;
        top: 5px;
        right: 12px;
        -webkit-transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 6;
        padding: 0;
        display: inline-block;
        outline: none;
        background-color: rgb(26, 25, 25);
        border: none;
        vertical-align: middle;
        white-space: nowrap;
        cursor: pointer;
        background-image: url('./assets/images/icon_closewindow.png');
        background-repeat: no-repeat;
        background-position: center center;
    }

    button:hover {
        background-image: url('./assets/images/icon_closewindow_overlay.png');
    }

    textarea, select, input, button {
        outline: none;
    }

    #welcomeDiv {
        width: 922px;
        height: 518px;
        background-image: url(~/ava/ava_welcome_dark_newquotes.png);
        background-repeat: no-repeat;
        background-size: 922px 418px;
        position: relative;
    }

    .btnDiv {
        position: absolute;
        top: 229px;
        right: 50px;
        width: 365px;
        height: 105px;
    }

    .YNbtn {
        width: 159px;
        height: 89px;
        float: left;
        z-index: 100;
        cursor: pointer;
    }

    #yesBtn {
        background-image: url(~/ava/ava_yes_regular.png);
    }

        #yesBtn:hover {
            background-image: url(~/ava/ava_yes_hover.png);
        }

        #yesBtn:active {
            background-image: url(~/ava/ava_yes_click.png);
        }


    #noBtn {
        background-image: url(~/ava/ava_no_regular.png);
    }

        #noBtn:hover {
            background-image: url(~/ava/ava_no_hover.png);
        }

        #noBtn:active {
            background-image: url(~/ava/ava_no_click.png);
        }
</style>
